import React, { useState } from "react";
import 'animate.css';
import Logo from "../resources/Logo petromin.png";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { useLocation, Link } from "react-router-dom";

function Navbar() {
  const [hamburgerState, setHamburgerState] = useState(false);
  const location = useLocation();

  const toggleHamburger = () => {
    setHamburgerState((prev) => !prev);
  };

  const isActive = (path) =>
    path === '/stavebniny'
      ? location.pathname === '/stavebniny'
      : location.pathname.startsWith(path);

  const linkClass = (path) =>
    `p-2 rounded transition-colors duration-200 ${
      isActive(path) ? 'bg-red-600 text-white' : 'hover:bg-red-700 hover:text-white'
    }`;

  const mobileLinkClass = (path) =>
    `block py-2 px-3 rounded transition-colors duration-200 ${
      isActive(path) ? 'text-red-600 font-extrabold' : ''
    }`;

  return (
    <div>
      <nav className="bg-white shadow-xl z-50 fixed top-0 left-0 w-full">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-red-600"></div>
        <div className="px-6 flex justify-between items-center mx-auto h-24">
          <Link to="/">
            <img src={Logo} alt="logo" className="h-12" />
          </Link>
          <div className="items-center space-x-2 text-xl font-semibold hidden lg:flex">
            <Link to="/stavebniny" className={linkClass('/stavebniny')}>Domov</Link>
            <Link to="/ponuka" className={linkClass('/ponuka')}>Ponuka</Link>
            <Link to="/doprava" className={linkClass('/doprava')}>Doprava</Link>
            <Link to="/contact" className={linkClass('/contact')}>Kontakt</Link>
          </div>
          <div className="lg:hidden cursor-pointer" onClick={toggleHamburger}>
            <AiOutlineMenu className="h-7 w-7" />
          </div>
        </div>
      </nav>

      {hamburgerState && (
        <div className="fixed top-0 left-0 bg-black bg-opacity-70 w-full h-full z-50 animate__animated animate__fadeIn animate__faster">
          <div className="absolute top-0 left-0 w-3/5 h-full p-10 bg-white overflow-y-auto no-scrollbar animate__animated animate__slideInLeft animate__faster">
            <div className="flex justify-between items-center">
              <Link to="/" onClick={toggleHamburger}>
                <img src={Logo} alt="logo" className="h-8" />
              </Link>
              <AiOutlineClose
                onClick={toggleHamburger}
                className="h-8 w-8 ml-4 rounded-xl border cursor-pointer shadow-lg p-1 hover:bg-red-600 hover:text-white transition-colors duration-200"
              />
            </div>
            <div className="font-medium text-lg border-b border-gray-300 mt-6">
              <p className="block my-4 text-gray-500">Petromin</p>
            </div>
            <ul className="space-y-2 p-4 font-bold text-xl mt-6">
              <li>
                <Link to="/stavebniny" onClick={toggleHamburger} className={mobileLinkClass('/stavebniny')}>Domov</Link>
              </li>
              <li>
                <Link to="/ponuka" onClick={toggleHamburger} className={mobileLinkClass('/ponuka')}>Ponuka</Link>
              </li>
              <li>
                <Link to="/doprava" onClick={toggleHamburger} className={mobileLinkClass('/doprava')}>Doprava</Link>
              </li>
              <li>
                <Link to="/cerpacia-stanica" onClick={toggleHamburger} className={mobileLinkClass('/cerpacia-stanica')}>Čerpacia stanica</Link>
              </li>
              <li>
                <Link to="/contact" onClick={toggleHamburger} className={mobileLinkClass('/contact')}>Kontakt</Link>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;
